export const categoryMeta: Record<string, { color: string }> = {
  Report: { color: "#3b82f6" },
  Analysis: { color: "#f59e0b" },
  Study: { color: "#06b6d4" },
  Benchmark: { color: "#5b8cff" },
  Survey: { color: "#22d3ee" },
};

export function getCategoryColor(cat: string) {
  return categoryMeta[cat]?.color ?? "color-mix(in srgb, var(--foreground) 60%, transparent)";
}

export const TOC_ITEMS = [
  { id: "methodology", label: "Methodology & test setup" },
  { id: "key-findings", label: "Key findings" },
  { id: "proxy-types", label: "Proxy type breakdown" },
  { id: "target-tiers", label: "Target tier analysis" },
  { id: "cost-analysis", label: "Cost-per-success analysis" },
  { id: "recommendations", label: "Recommendations" },
  { id: "conclusion", label: "Conclusion" },
];
